import { useState } from 'react';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon, LeftIcon } from 'foundations-assets';
import { useAchievementLessons, getMetadataLanguageFallback } from '../achievementQueries';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import { SuccessIcon } from 'foundations-assets';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurriculumInfo = ({
  publicId,
  language
}) => {
  var _useAchievementLesson;
  const lessons = (_useAchievementLesson = useAchievementLessons(publicId)) === null || _useAchievementLesson === void 0 ? void 0 : _useAchievementLesson.slice(0, 6);
  const {
    isMobile,
    isTablet,
    isDesktop,
    isNotTablet
  } = useMediaQuery();
  const [page, setPage] = useState(1);
  if (!lessons) return null;
  const pageSize = isTablet ? 5 : 6;
  const hasPartitions = lessons.length > pageSize;
  const maxPages = Math.ceil(lessons.length / pageSize);
  const startIndex = (Math.min(page, maxPages) - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const lessonsToDisplay = lessons.slice(startIndex, endIndex);
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: isDesktop ? '1200' : isNotTablet ? '500' : '0',
    paddingBlock: "1000",
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "400",
      children: [hasPartitions && /*#__PURE__*/_jsx(IconButton, {
        disabled: page === 1,
        onClick: () => setPage(Math.max(1, page - 1)),
        use: "transparent",
        children: /*#__PURE__*/_jsx(LeftIcon, {
          color: "icon-tertiary-default",
          size: "600"
        })
      }), /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(View, {
          textAlign: isTablet ? 'center' : undefined,
          children: /*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.certification.curriculumCompleted"
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          maxInlineSize: "600px",
          minBlockSize: "200px",
          children: /*#__PURE__*/_jsx(List, {
            children: lessonsToDisplay && lessonsToDisplay.map((lesson, i) => {
              const lessonName = getMetadataLanguageFallback(lesson.metadata, language).name;
              return /*#__PURE__*/_jsx(View, {
                as: "li",
                paddingBlock: "200",
                children: /*#__PURE__*/_jsxs(Flex, {
                  alignItems: "center",
                  gap: "400",
                  children: [/*#__PURE__*/_jsx(Box, {
                    flexShrink: 0,
                    children: /*#__PURE__*/_jsx(SuccessIcon, {
                      color: "icon-tertiary-default",
                      size: "400"
                    })
                  }), isMobile ? lessonName : /*#__PURE__*/_jsx(TruncateString, {
                    children: lessonName
                  })]
                })
              }, i);
            })
          })
        })]
      }), hasPartitions && /*#__PURE__*/_jsx(IconButton, {
        disabled: page === maxPages,
        onClick: () => setPage(Math.min(maxPages, page + 1)),
        use: "transparent",
        children: /*#__PURE__*/_jsx(RightIcon, {
          color: "icon-tertiary-default",
          size: "600"
        })
      })]
    })
  });
};
export default CurriculumInfo;